import { useDefaultFormData as useSharedDefaultFormData } from 'platform/shared/health-apps';
import {
  isLoggedIn,
  isProfileLoading,
  selectProfile,
} from 'platform/user/selectors';
import { useSelector } from 'react-redux';
import { selectTotalDisabilityRating } from '../selectors';
import { validateDateOfBirth } from '../utils/validation';

/**
 * Seeds the form with feature toggle view fields plus default view fields
 * derived from the user's authentication status, profile and disability rating.
 *
 * @param {{ toggleName: string, formKey: string }[]} toggles - toggle configs
 * @returns {void}
 */
export const useDefaultFormData = toggles => {
  const totalRating = useSelector(selectTotalDisabilityRating);
  const { dob, userFullName } = useSelector(selectProfile);
  const loggedIn = useSelector(isLoggedIn);
  const isLoadingProfile = useSelector(isProfileLoading);

  useSharedDefaultFormData(toggles, {
    skip: isLoadingProfile,
    extraFields: {
      'view:isLoggedIn': loggedIn,
      'view:totalDisabilityRating': totalRating,
      ...(loggedIn && {
        'view:veteranInformation': {
          veteranDateOfBirth: validateDateOfBirth(dob),
          veteranFullName: userFullName,
        },
      }),
    },
  });
};
